function setFinderState(root, isOpen, returnFocus = false) {
	const toggle = root.querySelector('[data-reading-finder-toggle]');
	const panel = root.querySelector('[data-reading-finder-panel]');
	const input = root.querySelector('[data-homepage-search-input]');
	const isWide =
		getComputedStyle(root).getPropertyValue('--reading-finder-wide').trim() ===
		'1';
	const panelIsAvailable = isWide || isOpen;

	root.classList.toggle('is-open', isOpen);
	toggle.setAttribute('aria-expanded', panelIsAvailable ? 'true' : 'false');
	panel.toggleAttribute('inert', !panelIsAvailable);
	panel.setAttribute('aria-hidden', panelIsAvailable ? 'false' : 'true');
	input.readOnly = !isWide;
	input.setAttribute('inputmode', isWide ? 'search' : 'none');
	if (isWide) input.removeAttribute('virtualkeyboardpolicy');
	else input.setAttribute('virtualkeyboardpolicy', 'manual');

	if (returnFocus && !isWide) toggle.focus();
}

export default function readingFinder() {
	const root = document.querySelector('[data-reading-finder]');
	if (!root || root.dataset.finderInitialized) return;
	root.dataset.finderInitialized = 'true';

	const shell = root.closest('.single-page-shell');
	const toggle = root.querySelector('[data-reading-finder-toggle]');
	const close = root.querySelector('[data-reading-finder-close]');
	const input = root.querySelector('[data-homepage-search-input]');
	const firstKey = root.querySelector('[data-keypad-value]');
	if (!shell || !toggle || !close || !input || !firstKey) return;

	const open = () => {
		setFinderState(root, true);
		requestAnimationFrame(() => firstKey.focus({ preventScroll: true }));
	};
	const closeFinder = (returnFocus = true) =>
		setFinderState(root, false, returnFocus);

	toggle.addEventListener('click', open);
	close.addEventListener('click', () => closeFinder());
	root.addEventListener('keydown', (event) => {
		if (
			event.key !== 'Escape' ||
			event.defaultPrevented ||
			!root.classList.contains('is-open')
		)
			return;
		event.preventDefault();
		closeFinder();
	});

	const observer = new ResizeObserver(() => {
		setFinderState(root, root.classList.contains('is-open'));
	});
	observer.observe(shell);
	setFinderState(root, false);
}
